import { render } from "./MarketAccountShippingServiceComponent.vue?vue&type=template&id=0b9dbb55"
import script from "./MarketAccountShippingServiceComponent.vue?vue&type=script&lang=js"
export * from "./MarketAccountShippingServiceComponent.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__